import { render, staticRenderFns } from "./candidatePlacingHistory.vue?vue&type=template&id=0d452713&"
import script from "./candidatePlacingHistory.vue?vue&type=script&lang=js&"
export * from "./candidatePlacingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports